import React, { useContext, useEffect, useState } from "react";
import { useParams, NavLink, useNavigate } from "react-router-dom";
import { Box, Tab, Tabs } from "@mui/material";
import Axios from "axios";
// import defaultPic from "../../resource/profile_pic/depic.png";
import Footer from "../Footer";
import BlogCard from "../Cards/BlogCard";
import { UserContext } from "../../context/UserContext";
import Spinner from "../Spinner";

const Category = () => {
  const { state } = useContext(UserContext);
  const [isLoading, setLoading] = useState(true);

  const navigate = useNavigate();

  const [blogs, setBlogs] = useState(0, {
    name: "",
    userId: "",
    createdAt: "",
    title: "",
    description: "",
    profilepic: "",
    image: "",
  });

  const [like, setLike] = useState(0);

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { articleType } = useParams();
  const chooseCategoryFn = async () => {
    const res = await Axios.get(
      `https://blogappserver-8sw1.onrender.com/category/${articleType}`
    );
    const categoryData = res.data;
    setBlogs(categoryData);
  };

  //like and unlike functionality..
  const likeArticleFn = async (id) => {
    try {
      return await Axios.put(
        "https://blogappserver-8sw1.onrender.com/articles/like",
        { likeId: id },
        {
          withCredentials: true,
        }
      )
        .then((res) => res.data)
        .then((result) => {
          const newData = blogs.map((item) => {
            if (item._id === result._id) {
              setLike(like + 1);
              return result;
            } else {
              setLike(like + 1);
              return item;
            }
          });
          setBlogs(newData);
        })
        .catch((err) => {
          navigate("/login");
        });
    } catch (e) {}
  };

  const unlikeArticleFn = async (id) => {
    try {
      return await Axios.put(
        "https://blogappserver-8sw1.onrender.com/articles/unlike",
        { likeId: id },
        {
          withCredentials: true,
        }
      )
        .then((res) => res.data)
        .then((result) => {
          const newData = blogs.map((item) => {
            if (item._id === result._id) {
              setLike(like - 1);
              return result;
            } else {
              setLike(like - 1);
              return item;
            }
          });
          setBlogs(newData);
        })
        .catch((err) => {
          navigate("/login");
        });
    } catch (e) {}
  };

  useEffect(() => {
    chooseCategoryFn();
    // Simulating data loading delay
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [articleType]);

  return (
    <>
      {/* scrolling tab - categories */}
      <div
        className="sroll-tab"
        style={{
          marginTop: "4px",
          position: "fixed",
          left: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
          zIndex: 1000,
          backgroundColor: "#fff",
        }}
      >
        <Box sx={{ maxHeight: "100vh", overflowX: "hidden" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="Categories Tabs"
          >
            <Tab label="Tech" component={NavLink} to="/../category/Tech" />
            <Tab label="Sports" component={NavLink} to="/../category/Sport" />
            <Tab
              label="Education"
              component={NavLink}
              to="/../category/Education"
            />
            <Tab
              label="Life Style"
              component={NavLink}
              to="/../category/Life Style"
            />
            <Tab label="Food" component={NavLink} to="/../category/Food" />
            <Tab label="Travel" component={NavLink} to="/../category/Travel" />
            <Tab
              label="Marketing"
              component={NavLink}
              to="/../category/Marketing"
            />
            <Tab
              label="Business"
              component={NavLink}
              to="/../category/Business"
            />
            <Tab
              label="Environment"
              component={NavLink}
              to="../category/Environment"
            />
            <Tab label="DIY" component={NavLink} to="../category/DIY" />
          </Tabs>
        </Box>
      </div>
      {/* Blog Field */}
      <>
        {isLoading ? (
          <>
            <Spinner />
          </>
        ) : Object.values(blogs).length === 0 ? (
          // Display a message to create a new blog
          <div className="container px-3 py-5 text-center">
            <div className="fs-5">
              <p>
                No blogs in this category.{" "}
                <NavLink to="/articles/new">Create a new blog</NavLink>
              </p>
            </div>
          </div>
        ) : (
          Object.values(blogs).map((blog, index) => {
            return (
              <div key={index}>
                {/* Blog Fields */}
                <div className="container-field">
                  <div className="blog-field card">
                    <BlogCard
                      id={blog._id}
                      userId={blog.user?._id}
                      profilePic={blog.user?.profilepic}
                      name={blog.user?.name}
                      createdAt={blog.createdAt}
                      title={blog.title}
                      description={blog.description}
                      blogImage={blog.image}
                    />

                    {/*like and comment functionality*/}
                    <div className="text-muted text-center">
                      {state ? (
                        blog.likes?.includes(state._id) ? (
                          // (article.likes?.includes('63c92ac522d471f4d2e81ce7'))
                          <i
                            className="fa fa-heart px-5 i-color"
                            style={{ fontSize: "18px" }}
                            onClick={() => unlikeArticleFn(`${blog._id}`)}
                          >
                            {blog.likes?.length}
                          </i>
                        ) : (
                          <i
                            className="fa fa-heart-o px-5"
                            style={{ fontSize: "18px" }}
                            onClick={() => likeArticleFn(`${blog._id}`)}
                          >
                            {blog.likes?.length}
                          </i>
                        )
                      ) : (
                        <i
                          className="fa fa-heart-o px-5"
                          style={{ fontSize: "18px" }}
                          onClick={() => navigate("/login")}
                        >
                          {blog.likes?.length}
                        </i>
                      )}
                      <NavLink to={`../../articles/${blog._id}`}>
                        <i
                          className="fa fa-comments-o px-5 m-link"
                          style={{ fontSize: "18px" }}
                        >
                          {blog.messages?.length}
                        </i>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        )}
      </>
      <Footer />
    </>
  );
};
export default Category;
